import type { InputHTMLAttributes, Ref } from 'react';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import type { IconDefinition } from 'atoms/icons';
import { turnIconIntoBackground } from 'lib/pictures';

const Root = styled.input`
  flex: 1;
  min-width: 0;
  width: auto;
  font: var(--t-16);
  line-height: calc(5 * var(--unit));
  appearance: none;
  border: none;
  border-radius: var(--unit);
  background-color: var(--c-nd-50);
  background-image: var(--icon);
  background-repeat: no-repeat;
  background-size: var(--double-unit) var(--double-unit);
  background-position: var(--intermediate-unit) center;
  padding: 0 var(--unit) 0 var(--paddingLeft);
`;

export type Props = {
  icon?: IconDefinition;
  ref?: Ref<HTMLInputElement>;
} & InputHTMLAttributes<HTMLInputElement>;

export const Input = ({ icon, ref, ...props }: Props) => {
  return (
    <Root
      style={
        {
          '--icon': icon ? `url(${turnIconIntoBackground(icon)})` : 'none',
          '--paddingLeft': icon ? `var(--quadruple-unit)` : `var(--unit)`,
        } as CSSProperties
      }
      {...props}
      ref={ref}
    />
  );
};
